import { Stack, SxProps } from '@mui/system'
import React from 'react'
import EditDownloadCategoryButton from './EditDownloadCategoryButton'
import AddSubcategoryButton from './AddSubcategoryButton'
import { DownloadsCategoryModel, DownloadsParent } from '../models'
import UploadFileButton from './UploadFileButton'
import { MAX_LAYER } from 'src/Libs/downloads'
interface Props {
  parent: DownloadsParent | undefined
  item: DownloadsCategoryModel
  sx?: SxProps
  isFirstLevel?: boolean
  selectCategory: (categoryId?: number) => void
}

const ServiceActions: React.FC<Props> = ({ parent, item, sx, isFirstLevel, selectCategory }) => {
  const hideAddButton = item.layer >= MAX_LAYER
  return (
    <Stack direction={'row'} alignItems={'center'} sx={sx} spacing={2}>
      <EditDownloadCategoryButton item={item} parent={parent} selectCategory={selectCategory} sx={{ padding: 0 }} />
      <UploadFileButton parent={item} sx={{ padding: 0 }} />
      {!hideAddButton && <AddSubcategoryButton parent={item} isFirstLevel={isFirstLevel} selectCategory={selectCategory} sx={{ padding: 0 }} />}
    </Stack>
  )
}

export default ServiceActions
